import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import Pagination from "react-js-pagination";
import { useDispatch } from "react-redux";
import {
  RaderAttendee_List,
  RaderAttendee_search,
} from "../../../actions/auth";
import Spinner from "../Spinner";
import { MY_PROFILE, SITE_URL } from "../../../actions/types";

const RadarAttendees = () => {
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [listReducer, setListReducer] = useState("");
  const [loadingData, setLoadingData] = useState(false);

  const [activePage, setActivePage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [searchData, setSearchData] = useState("");

  const dispatch = useDispatch("");

  useEffect(() => {
    setLoading(true);
    dispatch(RaderAttendee_List(activePage)).then((response) => {
      console.log(response, "response...");
      if (response) {
        setListReducer(response);
        setList(response?.data);
      }
      setLoading(false);
    });
  }, [activePage]);

  useEffect(() => {
    setLoading(true);
    dispatch(RaderAttendee_List(activePage)).then((response) => {
      console.log(response, "response...");
      if (response) {
        setListReducer(response);
        setList(response?.data);
      }
      setLoading(false);
    });
  }, []);

  console.log(list, "Listtttt...");

  const total = listReducer?.total;
  console.log(total, "total..");

  const handlePageChange = (pagenumber) => {
    if (pagenumber) {
      setLoadingData(true);
      dispatch(RaderAttendee_List(pagenumber)).then(() => {
        setLoadingData(false); // Stop loading
      });
    }
    setActivePage(pagenumber);
  };

  const searchList = (e) => {
    const data = e.target.value.trimStart();
    console.log(data, "mmmmmmm");
    setSearchData(data);
    setActivePage(1);

    if (e.target.value.length > 1) {
      setLoadingData(true);
      dispatch(RaderAttendee_search(e.target.value, activePage)).then(
        (response) => {
          console.log(response.data, "city_RES");
          debugger;
          setListReducer(response);
          if (response?.data?.length > 0) {
            setList(response?.data);
          } else {
            setList([]);
          }
          setLoadingData(false);
        }
      );
    } else {
      setLoadingData(true);
      dispatch(RaderAttendee_List(activePage)).then((response) => {
        if (response) {
          setListReducer(response);
          setList(response?.data);
        }
        setLoadingData(false);
      });
    }
    setLoadingData(false);
  };

  const handleSearch = () => {
    if (searchData.length > 1) {
      setLoadingData(true);
      dispatch(RaderAttendee_search(searchData, activePage)).then(
        (response) => {
          console.log(response.data, "city_RES");
          debugger;
          setListReducer(response);
          if (response?.data?.length > 0) {
            setList(response?.data);
          } else {
            setList([]);
          }
        }
      );
      setLoadingData(false);
    }

    // else {
    //   setLoadingData(true);
    //   dispatch(RaderAttendee_List(activePage)).then((response) => {
    //     if (response) {
    //       setListReducer(response);
    //       setList(response?.data);
    //     }
    //     setLoadingData(false);
    //   });
    // }
    // setLoadingData(false);
  };

  const calculateRange = () => {
    const currentPage = activePage;
    const itemsPerPage = 10;

    const startIndex = (currentPage - 1) * itemsPerPage + 1;

    let endIndex = currentPage * itemsPerPage;
    if (endIndex > total) {
      endIndex = total;
    }

    return `Showing ${startIndex} to ${endIndex} of ${total} entries`;
  };

  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  const handleSortChange = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });

    const sortedList = [...list].sort((a, b) => {
      if (key === "city") {
        // Sorting by the first radar city
        const cityA = a?.radar[0]?.city || "";
        const cityB = b?.radar[0]?.city || "";
        if (cityA < cityB) return direction === "asc" ? -1 : 1;
        if (cityA > cityB) return direction === "asc" ? 1 : -1;
        return 0;
      } else {
        if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
        if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
        return 0;
      }
    });

    setList(sortedList);
  };

  const handleClearSearch = () => {
    if (searchData) {
      setSearchData("");

      setLoading(true);
      dispatch(RaderAttendee_List(activePage)).then((response) => {
        console.log(response, "response...");
        if (response) {
          setListReducer(response);
          setList(response?.data);
        }
        setLoading(false);
      });
    }
  };

  // const handleKeyPress = (e) => {
  //   if (e.key == "Enter") {
  //     e.preventDefault();

  //     handleSearch();
  //   }
  // };

  return (
    <>
      <div id="wrapper">
        <Sidebar />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header />
            <div className="container-fluid">
              <div className="card shadow mb-4">
                <div className="card-header py-3">
                  <h6 className="m-0 font-weight-bold text-primary">
                    Radar Attendees
                  </h6>
                </div>
                <div className="card-body">
                  <div style={{ paddingLeft: 10, paddingRight: 10 }}>
                    <div className="row mb-2 ">
                      <div className="col-md-4">
                        <div>
                          <input
                            type="text"
                            className="form-control search-input-new"
                            placeholder="Search here"
                            value={searchData}
                            onChange={searchList}
                            // onKeyDown={handleKeyPress}
                            // onKeyDown={handleSearch}
                          />
                        </div>
                        {searchData.length >= 1 && (
                          <div
                            onClick={handleClearSearch}
                            className="cross-serach-new"
                          >
                            <i className="fa fa-times cursor-pointerr"></i>
                          </div>
                        )}
                      </div>
                      <div className="col-md-2">
                        <button
                          className="btn btn-primary form-control"
                          onClick={handleSearch}
                        >
                          Search
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {loading ? (
                  <div className="loader-container">
                    <div className="loaderss"></div>
                  </div>
                ) : (
                  <div style={{ paddingLeft: 30, paddingRight: 30 }}>
                    <table className="table radar-table">
                      <thead>
                        <tr>
                          <th scope="col">No</th>
                          <th scope="col">Profile</th>
                          <th scope="col">
                            Name
                            <i
                              onClick={() => handleSortChange("firstname")}
                              className="fa fa-sort cursor-pointerr"
                              height="15px"
                              width="15px"
                              style={{ marginLeft: 5 }}
                            ></i>
                          </th>
                          <th scope="col">
                            Email
                            <i
                              onClick={() => handleSortChange("email")}
                              className="fa fa-sort cursor-pointerr"
                              height="15px"
                              width="15px"
                              style={{ marginLeft: 5 }}
                            ></i>
                          </th>
                          <th scope="col">
                            Phone
                            <i
                              onClick={() => handleSortChange("phone")}
                              className="fa fa-sort cursor-pointerr"
                              height="15px"
                              width="15px"
                              style={{ marginLeft: 5 }}
                            ></i>
                          </th>
                          <th scope="col">
                            City
                            <i
                              onClick={() => handleSortChange("city")}
                              className="fa fa-sort cursor-pointerr"
                              height="15px"
                              width="15px"
                              style={{ marginLeft: 5 }}
                            ></i>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {loadingData ? (
                          <div className="overlay">
                            <div className="loader bg-transparent">
                              <Spinner />
                            </div>
                          </div>
                        ) : (
                          <>
                            {console.log(list, "mapLIst")}
                            {Array.isArray(list) && list && list?.length > 0 ? (
                              list?.map((attendee, index) => (
                                <>
                                  <tr key={attendee?._id}>
                                    <th scope="row">
                                      {(activePage - 1) * itemsPerPage +
                                        (index + 1)}
                                    </th>
                                    {/* <td>{attendee?.profile_image}</td> */}
                                    <td>
                                      <img
                                        src={
                                          MY_PROFILE +
                                          "/" +
                                          attendee?.profile_image
                                        }
                                        onError={(e) => {
                                          e.target.onerror = null; // Prevent infinite loop in case `noImage.png` also fails
                                          e.target.src = "img/noImage.png"; // Fallback image if loading fails
                                        }}
                                        style={{
                                          height: "65px",
                                          borderRadius: "50px",
                                          width: "65px",
                                        }}
                                      />
                                    </td>
                                    <td>
                                      {attendee?.firstname
                                        ? attendee?.firstname
                                        : "-"}
                                    </td>
                                    <td
                                      style={{
                                        width: "290px",
                                      }}
                                    >
                                      {attendee?.email ? attendee?.email : "-"}
                                    </td>
                                    <td>
                                      {attendee?.phone ? attendee?.phone : "-"}
                                    </td>
                                    {console.log(
                                      "attendee?.radar",
                                      attendee?.radar
                                    )}
                                    {/* <td>
                                      {attendee &&
                                        attendee?.radar.map((e) =>
                                          e.city ? e.city + " , " : "-"
                                        )}
                                    </td> */}
                                    <td>
                                      {attendee &&
                                        attendee?.radar.map((e, index) =>
                                          e.city
                                            ? `${e?.city}${
                                                index <
                                                attendee?.radar?.length - 1
                                                  ? ", "
                                                  : ""
                                              }`
                                            : "-"
                                        )}
                                    </td>
                                  </tr>
                                </>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={6}>
                                  <h5
                                    style={{ textAlign: "center" }}
                                    className="mt-3"
                                  >
                                    No results found
                                  </h5>
                                </td>
                              </tr>
                            )}
                          </>
                        )}
                      </tbody>
                    </table>

                    {list && list?.length > 0 ? (
                      <div className="d-flex justify-content-between mt-3 align-items-center">
                        <ul className="mt-3 ps-0">
                          <p>{calculateRange()}</p>
                        </ul>
                        <Pagination
                          activePage={activePage}
                          itemsCountPerPage={itemsPerPage}
                          totalItemsCount={total}
                          pageRangeDisplayed={10}
                          onChange={
                            total > itemsPerPage ? handlePageChange : null
                          }
                          itemClass="page-item"
                          linkClass={
                            total && total > 0
                              ? "page-link"
                              : "page-link disabled"
                          }
                        />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RadarAttendees;
